<template>
    <div>
        <div class="contianer">
            <!-- 顶部购物车 -->
            <div class="shoppingCat_title">
                <span class="shoppingCat_back" @click="goLink()"></span>
                <span class="shoppingCat_text ">订单管理</span>
            </div>

            <!-- 收货地址，姓名电话 -->
            <div class="shippingAddress">
                <div class="shippingAddress_left">
                    <img class="shippingAddress_left_img" src="/static/images/order/locationOrder.png" alt="定位" />
                </div>
                <div class="shippingAddress_center ellipsisStatus" @click="addressClick">
                    <div class="shippingAddress_center_status ellipsisStatus">
                        <span class="shippingAddress_center_loaction">北京市朝阳区企鹅文创园11栋1102北京市朝阳区企鹅文创园11栋1102</span>
                        <span class="shippingAddress_center_name">
                            <span>哈哈哈</span>
                            <span>12345678901</span>
                        </span>
                    </div>
                </div>
                <div class="shippingAddress_right">
                    <div class="right_arrow"></div>
                </div>

                <!-- 底部图片 -->
                <div class="shippingAddress_bottonImg">
                    <img src="/static/images/order/stripColor.png" alt="图片" />
                </div>

            </div>

            <!-- 多规格店铺 -->
            <div class="storeShopBox">
                <div class="storeShop">
                    <!-- 店铺名称 -->
                    <div class="storeShop_name">
                        <span>小白兔旗舰店</span>
                    </div>
                    <!-- 商品有多规格 -->
                    <div class="storeShop_moreStatus">
                        <div class="storeShop_moreStatus_box">
                            <!-- 左边图片 -->
                            <div class="storeShop_moreStatus_left">
                                <div class="storeShop_moreStatus_box">
                                    <img src="/static/images/order/locationOrder.png" alt="商品图片">
                                </div>
                                <div class="storeShop_moreStatus_box">
                                    <img src="/static/images/order/locationOrder.png" alt="商品图片">
                                </div>
                                <div class="storeShop_moreStatus_box">
                                    <img src="/static/images/order/locationOrder.png" alt="商品图片">
                                </div>
                                <div class="storeShop_moreStatus_box">
                                    <img src="/static/images/order/locationOrder.png" alt="商品图片">
                                </div>
                                <div class="storeShop_moreStatus_box">
                                    <img src="/static/images/order/locationOrder.png" alt="商品图片">
                                </div>
                            </div>
                            <!-- 右边总件数 -->
                            <div class="storeShop_moreStatus_right" @click="allShopNumber">
                                <img src="/static/images/ellipsis.png" alt="图片">
                                <span>共122件</span>
                            </div>
                        </div>
                        <!-- 配送方式 -->
                        <div class="distribution" @click="distributionClick">
                            <span class="distribution_flg">配送方式：</span>
                            <span class="distribution_change ellipsisStatus">请选择</span>
                            <div class="right_arrow"></div>
                        </div>
                        <!-- 备注 -->
                        <div class="distribution_note">
                            <span class="distribution_flg">备注：</span>
                            <div class="textareaParent" contenteditable="true">
                                {{textAreaValue1}}
                                <textarea v-model="textAreaValue1" class="textareaNote" placeholder="给商家留言(45个汉字以内)" maxlength="45">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
             <!-- 单规格店铺 -->
            <div class="storeShopBox">
                <div class="storeShop">
                    <!-- 店铺名称 -->
                    <div class="storeShop_name">
                        <span>小白兔旗舰店</span>
                    </div>
                    <!-- 商品单规格 -->
                    <div class="storeShop_oneStatus">
                        <div class="storeShop_oneStatus_top">

                            <div class="storeShop_oneStatus_left">
                                <img src="/static/images/order/locationOrder.png" alt="商品图片">
                            </div>
                            <div class="storeShop_oneStatus_right">
                                <span class="storeShop_oneStatus_right_text"><span class="onestatusProTag">支付卡</span> 佳能（Canon）PowerShot G7 X Mark II 数码相机 Vlog视频拍摄佳能（Canon）PowerShot G7 X Mark II 数码相机 Vlog视频拍摄 </span>
                                <span class="storeShop_oneStatus_right_reduce">
                                    <span>会员专享价</span>
                                    <span>手机下单立减￥55.99</span>
                                </span>
                                <div class="storeShop_oneStatus_right_price">
                                    <span class="price_left">
                                        <span class="price_left_symbol">￥</span>
                                        <span>3899</span>
                                    </span>
                                    <span class="price_right">
                                        x<span>14</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 备注 -->
                    <div class="distribution_note">
                        <span class="distribution_flg">备注：</span>
                        <div class="textareaParent textareaParent_long" contenteditable="true">
                            {{textAreaValue}}
                            <textarea v-model="textAreaValue" class="textareaNote" placeholder="给商家留言(45个汉字以内)" maxlength="45">
                            </textarea>
                        </div>
                    </div>
                </div>
                    <!-- 小计，总价格 -->
                    <div class="storeShop_subtotal">
                        <div class="storeShop_subtotal_left">
                            <span>必须使用30000消费积分</span>
                        </div>
                        <div class="storeShop_subtotal_right">
                            <span class="storeShop_subtotal_num">共5件</span>
                            <span class="storeShop_subtotal_price">
                                <span>小计:</span>
                                <span class="price_total">
                                    <span class="price_left_symbol">￥</span>
                                    <span>3899</span>
                                </span>
                            </span>
                        </div>
                    </div>
            </div>

            <!-- 自定义表单名称 -->
            <div class="customFromBox">
                <div class="customFrom">
                    <div class="customFrom_title">
                        <span>自定义表单名称</span>
                    </div>
                    <!-- 内容 -->
                    <div class="customFrom_content">
                        <!-- 用户名 -->
                        <div class="customFrom_content_title">
                            <span class="title_warn">*</span>
                            <span class="customFrom_content_titleWidth">请输入用户名</span>
                             <div class="customFrom_content_title_right">
                                 <div :class="true ? 'title_input_warn' : ''">
                                    <input type="text" placeholder="文本默认值">
                                 </div>
                            </div>
                        </div>
                        <!-- 密码 -->
                        <div class="customFrom_content_title">
                            <span class="title_warn">*</span>
                            <span class="customFrom_content_titleWidth">请输入密码</span>
                             <div class="customFrom_content_title_right">
                                 <div :class="true ? 'title_input_warn' : ''">
                                    <input type="text" placeholder="请输入密码">
                                 </div>
                            </div>
                        </div>
                        <!-- 标题 -->
                        <div class="customFrom_content_title">
                            <span class="customFrom_content_titleWidth">单题单题单题单题单题单题单题单题单题单题s</span>
                             <div class="customFrom_content_title_right">
                                <input type="text" placeholder="123">
                                <div class="customFrom_content_prompt">
                                    <img src="/static/images/warn.png" alt="提示语">
                                    <span>单行文本的提示语</span>
                                </div>
                            </div>
                        </div>
                        <!-- 单选类型标题 -->
                        <div class="customFrom_content_ridaoBox">
                            <div class="radioBox_title">
                                <span>单选类型标题</span>
                            </div>
                            <div class="customFrom_content_ridao">
                                <div
                                    :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                    v-if="true"
                                    >
                                    <img src="/static/images/check.png" alt="check" v-show="false" />
                                </div>
                                <span>选项A</span>
                            </div>
                            <div class="customFrom_content_ridao">
                                <div
                                    :class=" true ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                    v-if="true"
                                    >
                                    <img src="/static/images/check.png" alt="check" v-show="true" />
                                </div>
                                <span>选项B</span>
                            </div>
                            <!-- 单选类型提示语 -->
                            <div class="customFrom_contentPrompt">
                                <div class="customFrom_content_prompt">
                                    <img src="/static/images/warn.png" alt="提示语">
                                    <span>单行文本的提示语</span>
                                </div>
                            </div>
                        </div>
                        <!-- 下拉类型标题 -->
                        <div class="customFrom_content_title customFrom_content_downtitle" @click="changRadio">
                            <span class="customFrom_content_titleWidth">标题</span>
                             <div class="customFrom_content_title_right">
                                <div>123</div>
                                <div class="customFrom_content_prompt">
                                    <img src="/static/images/warn.png" alt="提示语">
                                    <span>单行文本的提示语</span>
                                </div>
                            </div>
                                <div class="right_arrow">

                                </div>
                        </div>
                        <!-- 多选类型标题 -->
                        <div class="customFrom_content_ridaoBox">
                            <div class="radioBox_title">
                                <span>多选类型标题</span>
                            </div>
                            <div class="customFrom_content_ridao">
                                <div
                                    :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio customFrom_content_checkbox' : 'shoppingContent_radio customFrom_content_checkbox'"
                                    v-if="true"
                                    >
                                    <img src="/static/images/check.png" alt="check" v-show="false" />
                                </div>
                                <span>选项A</span>
                            </div>
                            <div class="customFrom_content_ridao">
                                <div
                                    :class=" true ? 'shoppingContent_checkRadio shoppingContent_radio customFrom_content_checkbox' : 'shoppingContent_radio customFrom_content_checkbox'"
                                    v-if="true"
                                    >
                                    <img src="/static/images/check.png" alt="check" v-show="true" />
                                </div>
                                <span>选项B</span>
                            </div>
                            <!-- 单选类型提示语 -->
                            <div class="customFrom_contentPrompt">
                                <div class="customFrom_content_prompt">
                                    <img src="/static/images/warn.png" alt="提示语">
                                    <span>单行文本的提示语</span>
                                </div>
                            </div>
                        </div>
                        <!-- 日期类型标题 -->
                        <div class="customFrom_content_title customFrom_content_downtitle">
                            <span class="customFrom_content_titleWidth">日期类型标题</span>
                             <div class="customFrom_content_title_right">
                                <div>年/月/日</div>
                                <div class="customFrom_content_prompt">
                                    <img src="/static/images/warn.png" alt="提示语">
                                    <span>单行文本的提示语</span>
                                </div>
                            </div>
                                <div class="right_arrow">

                                </div>
                        </div>

                        <!-- 图片上传标题 -->
                        <div class="customFrom_content_uploadImgBox">
                            <div class="radioBox_title">
                                <span>单选类型标题</span>
                            </div>
                            <div class="uploadPicBox">
                                <div class="uploadImg">
                                    <!-- 中间加号 -->
                                    <div class="uploadImgCross"></div>
                                    <div class="uploadImgVertical"></div>
                                </div>
                               <div class="customFrom_contentPrompt">
                                    <div class="customFrom_content_prompt">
                                        <img src="/static/images/warn.png" alt="提示语">
                                        <span>单行文本的提示语</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 限制大小 -->
                            <span class="uploadImg_warning">仅支持上传5M以内的图片如JPG,PNG,GIF等格式</span>
                        </div>

                        <!-- 文件上传标题 -->
                        <div class="customFrom_content_uploadImgBox">
                            <div class="radioBox_title">
                                <span>单选类型标题</span>
                            </div>
                            <div class="uploadFileBox">
                                <div class="uploadFile">
                                    <!-- 中间加号 -->
                                    <img src="/static/images/order/upLoadOrder.png" alt="上传文件">
                                    <span>上传文件</span>
                                </div>
                            </div>
                            <div class="customFrom_contentPrompt">
                                    <div class="customFrom_content_prompt">
                                        <img src="/static/images/warn.png" alt="提示语">
                                        <span>单行文本的提示语</span>
                                    </div>
                                </div>
                            <!-- 限制大小 -->
                            <span class="uploadImg_warning">仅支持上传5M以内的图片如JPG,PNG,GIF等格式</span>
                        </div>
                    </div>

                    <!-- 收起 -->
                    <div class="packUp">
                        <span class="packUpText">收起</span>
                    </div>
                </div>
            </div>

            <!-- 身份证号 -->
            <div class="idNumber">
                <!-- 标题 -->
                <div class="customFrom_content_title">
                    <span class="customFrom_content_title_left">姓名</span>
                    <div class="customFrom_content_title_right">
                        <input type="text" placeholder="订单包含跨境商品,请填写收货人身份证号">
                    </div>
                </div>
                <div class="customFrom_content_title">
                    <span class="customFrom_content_title_left">身份证号</span>
                    <div class="customFrom_content_title_right">
                        <input type="text" placeholder="订单包含跨境商品,请填写收货人身份证号">
                    </div>
                </div>
            </div>

            <!-- 代金券,红包支付卡 -->
            <div class="paymentCardBox">
                <div class="paymentCard">
                    <div class="integral" @click="payWayClick">
                        <div class="paymentChild">
                            <span>支付方式</span>
                            <!-- 请选择 -->
                            <div class="paymentChild_right">
                                <span>请选择</span>
                                <div class="right_arrow"></div>
                            </div>                 
                        </div>
                    </div>
                    <div class="integral" @click="payCardClick">
                        <div class="paymentChild">
                            <span>支付卡</span>
                            <!-- 请选择 -->
                            <div class="paymentChild_right">
                                <span>请选择</span>
                                <div class="right_arrow"></div>
                            </div>                    
                        </div>
                    </div>
                    <div class="integral" @click="hongbaoClick">
                        <div class="paymentChild">
                            <span>红包</span>
                            <!-- 请选择 -->
                            <div class="paymentChild_right">
                                <span>请选择</span>
                                <div class="right_arrow"></div>
                            </div>                 
                        </div>
                    </div>
                    <div class="integral" @click="vouchersClick">
                        <div class="paymentChild">
                            <span>代金券</span>
                            <!-- 请选择 -->
                            <div class="paymentChild_right">
                                <span>请选择</span>
                                <div class="right_arrow"></div>
                            </div>                 
                        </div>
                    </div>
                    
                    <!-- 消费积分,余额 -->
                    <div class="integral specialPadding">
                        <div class="paymentChild">
                            <div class="paymentChild_pay">
                                <span class="paymentChild_payText">支付方式</span>
                                <span class="packUpText">详情</span>
                            </div>
                            <!-- 请选择 -->
                            <div class="paymentChild_right">
                                <!-- 提示标识 -->
                                    <div class="warn_text">
                                        <span class="warn_text_left">必须使用300消费积分</span>
                                        <span class="warn_text_right">x</span>
                                    </div>

                                <!-- <span style="color:#222222">本次最多可抵 ¥99.00</span> -->
                                <span style="color:#FF9900">您的消费积分不足，请调整商品后下单</span>
                                <!-- <div @click="selectStatus" :class="valueFlg ? 'marquee marqueeSelect' : 'marquee'">
                                    <div :class="valueFlg ? 'marqueeButton marqueeButtonSelect' : 'marqueeButton'"></div>
                                </div> -->
                            </div>
                        </div>
                        <div class="paymentStatus">
                            <span>剩余: 3123，本次最多可用300，抵 ￥99.00</span>
                            <span class="xiugai">修改</span>        
                        </div> 
                    </div>

                    <!-- 支付密码 -->
                    <div class="integral specialPadding">
                       <div class="customFrom_content_title" style="border-bottom:0;padding:0;">
                            <span>单行文本标题</span>
                             <div class="customFrom_content_title_right customFrom_content_title_rightPadding">
                                <input class="passwordInput" type="password" placeholder="请输入登录密码">
                                <div class="customFrom_content_prompt">
                                    <img src="/static/images/order/redWarnOrder.png" alt="提示语">
                                    <span style="color:#FA230A">单行文本的提示语</span>
                                </div>
                            </div>
                        </div>
                        <div class="specialPadding">
                            <span>未设置支付密码,请使用登录密码</span>
                            <span style="color:#222;">找回密码</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 各种优惠满减 -->
            <div class="preferentialBox">
                <div class="preferential">
                    <!-- 商铺 -->
                    <div class="preferential_content">
                        <span>商铺价格</span>
                        <span>￥1000.00</span>
                    </div>
                    <div class="preferential_content">
                        <span>商铺价格</span>
                        <span class="preferential_children_right">￥1000.00</span>
                    </div>
                    <div class="preferential_content">
                        <span>商铺价格</span>
                        <span class="preferential_children_right">￥1000.00</span>
                    </div>
                </div>
            </div>

            <!-- 提交订单 -->
            <div class="upOrder">
                <div class="upOrder_left">
                    <span>需支付</span>
                    <span class="upOrder_left_price">¥1000.00</span>
                </div>
                <div class="upOrder_right">
                    <span>提交订单</span>
                </div>
            </div>
        </div>

       
        <!-- 第一层全屏遮罩层 -->
        <div class="fullScreenRadio" v-if="ScreenFlg"  @click="closeShadow"></div>
        
         <!-- 单选框弹窗 -->
        <div class="screenRadioBox"  v-if="radioScreenFlg">
            <div class="screenRadio">
                <div class="screenRadio_title">
                    <span>请选择</span>                        
                </div>
                <div class="screenRadio_content">
                    <div class="screenRadio_content_children">
                        <div class="customFrom_content_ridao screenRadio_children">
                            <div
                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                v-if="true"
                                >
                                <img src="/static/images/check.png" alt="check" v-show="false" />
                            </div>

                            <span>第一个选项</span>
                        </div>
                    </div>
                        <div class="screenRadio_content_children">
                        <div class="customFrom_content_ridao screenRadio_children">
                            <div
                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                v-if="true"
                                >
                                <img src="/static/images/check.png" alt="check" v-show="false" />
                            </div>
                            
                            <span>第一个选项</span>
                        </div>
                    </div>
                        <div class="screenRadio_content_children">
                        <div class="customFrom_content_ridao screenRadio_children">
                            <div
                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                v-if="true"
                                >
                                <img src="/static/images/check.png" alt="check" v-show="false" />
                            </div>
                            
                            <span>第一个选项</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 第二层全屏遮罩层 -->
        <div class="fullScreenRadio2" v-if="ScreenFlg2"  @click="closeShadow2"></div>
        <!-- 绑定支付卡弹窗 -->
        <div class="payCardBox" v-if="payScreenFlg">
            <div class="payCardChildren">
                <div class="payCardChildren_title">
                    <span>绑定支付卡</span>
                </div>
                <div class="payCardChildren_num">
                    <div class="payCardChildren_numTitle">
                        <span>请输入支付卡卡号</span>
                    </div>
                    <input class="writeContent" type="text">
                </div>
                <div class="payCardChildren_num">
                    <div class="payCardChildren_numTitle">
                        <span>请输入支付卡密码</span>
                    </div>
                    <input class="writeContent" type="password">
                </div>
            </div>
            <!-- 底部取消，立即绑定 -->
            <div class="footerBtn">
                <span @click="closeShadow2">取消</span>
                <span>立即绑定</span>
            </div>
        </div>

        <!-- 支付方式说明 -->
        <div class="payWayMyBox" v-if="payWayFlg">
            <div class="payWayMy">
                <div class="payWayMy_title">
                    <span>说明</span>
                </div>
                <div class="payWayMy_content">
                    <span>
                        文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标
                        文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标签文本标
                    </span>
                </div>
            </div>
            <!-- 确认按钮 -->
            <div class="payWayMy_btn" @click="closePayWayFlg">
                <span>确认</span>
            </div>
        </div>
        
        <!-- 添加收货地址 -->
        <OrderPopup ref="customAddress">
            <div
            slot="PoperContentFull"
            class="addressFullBox"
            >

            <!-- 添加收货地址 -->
            <div class="shoppingCat_title">
                <span class="shoppingCat_back" @click="goBack()"></span>
                <span class="shoppingCat_text ">订单管理</span>
            </div>

            <!-- 微信收货地址 -->
            <div class="weixinAdress">
                <div class="weixinAdress_img">
                    <img src="/static/images/weixin_icon.png" alt="微信">
                </div>
                <div class="weixinAdress_text">
                    <span>点击获取微信收货地址点击获取微信收货地址点击获取微信收货地址点击获取微信收货地址</span>
                </div>
                <div class="weixinAdress_closeIcon">
                    <span class="weixinAdress_closeIcon_left"></span>
                    <span class="weixinAdress_closeIcon_right"></span>
                </div>
            </div>
            <!-- 设为默认地址 -->
            <div class="defaultAddress">
                <div class="defaultAddress_left">
                    <span>设为默认地址</span>
                </div>
                <div class="defaultAddress_right">
                    <div @click="selectStatus" :class="valueFlg ? 'marquee marqueeSelect' : 'marquee'">
                        <div :class="valueFlg ? 'marqueeButton marqueeButtonSelect' : 'marqueeButton'"></div>
                    </div>
                </div>
            </div>
            <!-- 收货人基本信息 -->
            <div class="address_personInfoBox">
               <div class="address_personInfo">
                   <div class="address_personInfo_children">
                       <span class="subclass">收货人姓名</span>
                       <input type="text" placeholder="请输入" class="personWrite">
                       <div>
                            <img src="" alt="">
                       </div>
                   </div>
                   <div class="address_personInfo_children" @click="changeCity">
                       <span class="subclass">城市</span>
                       <div class="personWrite">请选择</div>
                       <div class="cityPerson">
                            <img src="/static/images/order/cityOrder.png" alt="城市">
                       </div>
                   </div>
                   <div class="address_personInfo_children">
                       <span class="subclass">收货人姓名收货人姓名收货人姓名</span>
                       <textarea placeholder="请输入" style="padding:0;margin:0;" class="personWrite" cols="10" rows="5"></textarea>
                   </div>
               </div>
            </div>

            <!-- 自定义内容 -->
            <div class="address_personInfoBox">
               <div class="address_personInfo">
                   <div class="address_personInfo_children">
                       <span class="subclass">收货人姓名</span>
                       <div class="distribution_note">
                            <div class="textareaParent" contenteditable="true">
                                {{textAreaValue1}}
                                <textarea v-model="textAreaValue1" class="textareaNote" placeholder="给商家留言(45个汉字以内)" maxlength="45">
                                </textarea>
                            </div>
                        </div> 
                   </div>
                   <div class="address_personInfo_children">
                       <span class="subclass">收货人姓名</span>
                       <div class="distribution_note">
                            <div class="textareaParent" contenteditable="true">
                                {{textAreaValue1}}
                                <textarea v-model="textAreaValue1" class="textareaNote" placeholder="给商家留言(45个汉字以内)" maxlength="45">
                                </textarea>
                            </div>
                        </div> 
                   </div>
                   
                   <div class="address_personInfo_children" @click="changRadio">
                       <span class="subclass">自定义单选</span>
                       <!-- <input type="text" placeholder="请输入" class="personWrite"> -->
                       <div class="personWrite">请选择</div>
                       <div class="cityPerson">
                            <div class="right_arrow"></div>
                       </div>
                   </div>
                   <div class="address_personInfo_children" @click="changeCheckBox">
                       <span class="subclass">自定义多选</span>
                       <!-- <input type="text" placeholder="请输入" class="personWrite"> -->
                       <div class="personWrite">请选择</div>
                       <div class="cityPerson">
                            <div class="right_arrow"></div>
                       </div>
                   </div>
               </div>
            </div>
          
          <!-- 顶部保存 -->
          <div class="addressFullBox_save" @click="closeFullAddress">
              <span>保存</span>
          </div>
        </div>
        </OrderPopup>

      <!-- 选择收货地址 -->
      <OrderPopup ref="customChangeCity" @closeCustomFun="closeCustom">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox">
                <div class="changeCityBox_top">
                    <div class="changeCityBox_top_left">
                        <span>请选择收货地址</span>

                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon" @click="closeCustom">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>
                <div class="changeCityBox_content">
                    <!-- 没有查到定位 -->
                    <div class="changeCityBox_content_noValueBox">
                        <div class="changeCityBox_content_noValue">
                            <img src="/static/images/order/cityContent.png" alt="城市">
                            <span class="noLocation">没有查询到您的定位</span>
                            <span class="openPermissions">请确认您已打开位置获取权限</span>
                        </div>
                        <!-- 努力加载中 -->
                        <!-- <div class="changeCityBox_content_noValue">
                            <span class="openPermissions">努力加载中...</span>
                        </div> -->
                    </div>
                </div>
            </div>

            <div class="PoperContentBtn" @click="closeCustom">确认</div>
        </div>
      </OrderPopup>

      <!-- 选择多选 -->
      <OrderPopup ref="customChangeCheckBox" @closeCheckBoxFun="closeCheckBox">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCheckBox">
                <div class="changeCityBox_top">
                    <div class="changeCityBox_top_left">
                        <span>请选择</span>
                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>

                <div class="changeCheckBox_content">
                    <div class="changeCheckBox_content_children">
                        <span>第一个选项</span>
                       <div class="customFrom_content_ridao">
                                <div
                                    :class=" true ? 'shoppingContent_checkRadio shoppingContent_radio customFrom_content_checkbox' : 'shoppingContent_radio customFrom_content_checkbox'"
                                    v-if="true">
                                    <img src="/static/images/check.png" alt="check" v-show="true" />
                                </div>
                        </div>
                    </div>
                    <div class="changeCheckBox_content_children">
                        <span>第一个选项</span>
                       <div class="customFrom_content_ridao">
                                <div
                                    :class=" true ? 'shoppingContent_checkRadio shoppingContent_radio customFrom_content_checkbox' : 'shoppingContent_radio customFrom_content_checkbox'"
                                    v-if="true">
                                    <img src="/static/images/check.png" alt="check" v-show="true" />
                                </div>
                        </div>
                    </div>
                    <div class="changeCheckBox_content_children">
                        <span>第一个选项</span>
                       <div class="customFrom_content_ridao">
                                <div
                                    :class=" true ? 'shoppingContent_checkRadio shoppingContent_radio customFrom_content_checkbox' : 'shoppingContent_radio customFrom_content_checkbox'"
                                    v-if="true">
                                    <img src="/static/images/check.png" alt="check" v-show="true" />
                                </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="PoperContentBtn" @click="closeCheckBox">确认</div>
        </div>
      </OrderPopup>

      <!-- 选择城市 -->
       <OrderPopup ref="customChangeMyCity" @closeCityFun="closeCity">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox">
                
                <div class="changeCityBox_top changeCityBoxChildren">
                    <div class="changeCityBox_top_left">
                        <span>请选择城市</span>
                         <div class="changeCityBox_changTitle">
                            <span class="selectCity">请选择</span>
                            <span>请选择</span>
                        </div>
                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon" @click="closeCity">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>
                <div class="changeMyCityBox_content cityBox_content_noHeight">
                    <div class="cityArea slectCityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区</span>
                    </div>
                    <div class="cityArea">
                        <span>城区111</span>
                    </div>
                </div>
               
            </div>

            <!-- <div class="PoperContentBtn" @click="closeCity">确认</div> -->
        </div>
      </OrderPopup>

        <!-- 支付卡 -->
      <OrderPopup ref="customPayCard" @closepayCardFun="closePayCard">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox">
                <div>
                    <div class="changeCityBox_top" style="border-bottom:0;">
                        <div class="changeCityBox_top_left">
                            <span>支付卡</span>
                        </div>
                        <div class="changeCityBox_top_right">
                        <div class="weixinAdress_closeIcon" @click="closePayCard">
                                <span class="weixinAdress_closeIcon_left"></span>
                                <span class="weixinAdress_closeIcon_right"></span>
                            </div>
                        </div>
                    </div>
                     <div v-if="true" class="addPayCard addHavePayCard" @click="bindingCardClick">
                            <div class="addPayCard_symbol">
                                <div class="uploadImgCross"></div>
                                <div class="uploadImgVertical"></div>
                            </div>
                            <span class="bindingCard">绑定新的支付卡</span>
                        </div>
                </div>
                <div class="changeCityBox_content" :class=" false ? 'centerClass' : '' ">
                    <div class="payCardBox_content">

                    <!-- 支付卡 -->
                    <!-- 没有支付卡 -->
                    <div class="changeCityBox_content_noValueBox" v-if="false">
                        <div class="changeCityBox_content_noValue payCard_noCard">
                            <img src="/static/images/order/envelopeOrder.png" alt="城市">
                            <span class="openPermissions">您还没有可以使用的红包</span>
                            <div class="addPayCard" @click="bindingCardClick">
                                <div class="addPayCard_symbol">
                                    <div class="uploadImgCross"></div>
                                    <div class="uploadImgVertical"></div>
                                </div>
                                <span class="bindingCard">绑定新的支付卡</span>
                            </div>
                        </div>
                    </div>
                    <!-- 有支付卡 -->
                    <div class="changeCityBox_content_ValueBox">
                        <div class="changeVouchers_ValueBox">
                            <div class="changeVouchers_Value" :class=" false ? 'changeHaveValue' :'changeHaveValueTwo' ">
                                <div class="changeVouchers_Value_children have_card_children">
                                    <!-- 左边价格，规则-->
                                    <div class="changeVouchers_Value_children_left">
                                        <div class="changeVouchers_Value_children_top">
                                            <div class="changeVouchers_children_top_price">
                                                <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            </div>
                                            <div class="changeVouchers_Value_children_top_guize">
                                                <span class="first_guize" style="display:block;">使用规则：</span>
                                                <span>订单满￥9999可使用</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 右边点选按钮 -->
                                    <div class="changeVouchers_Value_children_right">
                                        <div class="customFrom_content_ridao">
                                            <div
                                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                                v-if="true"
                                                >
                                                <img src="/static/images/check.png" alt="check" v-show="false" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="changeVouchers_Value_children have_card_children">
                                    <!-- 左边价格，规则-->
                                    <div class="changeVouchers_Value_children_left">
                                        <div class="changeVouchers_Value_children_top">
                                            <div class="changeVouchers_children_top_price">
                                                <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            </div>
                                            <div class="changeVouchers_Value_children_top_guize">
                                                <span class="first_guize" style="display:block;">使用规则：</span>
                                                <span>订单满￥9999可使用</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 右边点选按钮 -->
                                    <div class="changeVouchers_Value_children_right">
                                        <div class="customFrom_content_ridao">
                                            <div
                                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                                v-if="true"
                                                >
                                                <img src="/static/images/check.png" alt="check" v-show="false" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="changeVouchers_Value_children have_card_children">
                                    <!-- 左边价格，规则-->
                                    <div class="changeVouchers_Value_children_left">
                                        <div class="changeVouchers_Value_children_top">
                                            <div class="changeVouchers_children_top_price">
                                                <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            </div>
                                            <div class="changeVouchers_Value_children_top_guize">
                                                <span class="first_guize" style="display:block;">使用规则：</span>
                                                <span>订单满￥9999可使用</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 右边点选按钮 -->
                                    <div class="changeVouchers_Value_children_right">
                                        <div class="customFrom_content_ridao">
                                            <div
                                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                                v-if="true"
                                                >
                                                <img src="/static/images/check.png" alt="check" v-show="false" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="changeVouchers_Value_children have_card_children">
                                    <!-- 左边价格，规则-->
                                    <div class="changeVouchers_Value_children_left">
                                        <div class="changeVouchers_Value_children_top">
                                            <div class="changeVouchers_children_top_price">
                                                <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            </div>
                                            <div class="changeVouchers_Value_children_top_guize">
                                                <span class="first_guize" style="display:block;">使用规则：</span>
                                                <span>订单满￥9999可使用</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 右边点选按钮 -->
                                    <div class="changeVouchers_Value_children_right">
                                        <div class="customFrom_content_ridao">
                                            <div
                                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                                v-if="true"
                                                >
                                                <img src="/static/images/check.png" alt="check" v-show="false" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="changeVouchers_Value_children have_card_children">
                                    <!-- 左边价格，规则-->
                                    <div class="changeVouchers_Value_children_left">
                                        <div class="changeVouchers_Value_children_top">
                                            <div class="changeVouchers_children_top_price">
                                                <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            </div>
                                            <div class="changeVouchers_Value_children_top_guize">
                                                <span class="first_guize" style="display:block;">使用规则：</span>
                                                <span>订单满￥9999可使用</span>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- 右边点选按钮 -->
                                    <div class="changeVouchers_Value_children_right">
                                        <div class="customFrom_content_ridao">
                                            <div
                                                :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                                v-if="true"
                                                >
                                                <img src="/static/images/check.png" alt="check" v-show="false" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            <div class="PoperContentBtn" @click="closePayCard">确认</div>
        </div>
      </OrderPopup>

      <!-- 红包 -->
      <OrderPopup ref="customHongbao" @closeHongbaoFun="closeHongbao">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox">
                <div class="changeCityBox_top" style="border-bottom:0;">
                    <div class="changeCityBox_top_left">
                        <span>红包</span>
                        <div class="changeCityBox_changTitle">
                            <span>最多使用2个红包</span>
                        </div>
                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon" @click="closeHongbao">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>
                <!-- 没有红包 -->
                <div class="changeCityBox_content" v-if="false">
                    <div class="changeCityBox_content_noValueBox">
                        <div class="changeCityBox_content_noValue payCard_noCard">
                            <img src="/static/images/order/envelopeOrder.png" alt="城市">
                            <span class="openPermissions">您还没有可以使用的红包</span>
                        </div>
                    </div>
                </div>
                <!-- 有红包 -->
                <div class="changeCityBox_content" style="background-color:#F6F6F6;">
                    <div class="haveHongbao">
                        <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                         <div class="haveHongbao_children">
                            <div class="haveHongbao_children_price">
                                <span>￥</span>
                                <span>35</span>
                            </div>
                            <div class="haveHongbao_children_data">
                                <span>有效期至:2019-11-11有效期至:2019-11-11有效期至:2019-11-11</span>
                            </div>
                            <div class="haveHongbao_children_ridao">
                                <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="PoperContentBtn" @click="closeHongbao">确认</div>
        </div>
      </OrderPopup>

      <!-- 支付方式 -->
      <OrderPopup ref="customPayWay" @closePayWayFun="closePayWay">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox payWayBox">
                <div class="changeCityBox_top" style="border-bottom:0;">
                    <div class="changeCityBox_top_left">
                        <span>支付方式</span>
                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon" @click="closePayWay">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>
                <!-- 支付方式 -->
                <div class="payWay_content">
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <span>在线支付</span>
                            <img src="" alt="">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children selectPayWay">
                        <div class="payWay_content_children_left">
                            <span>在线支付</span>
                            <img @click="instructionsClick" src="/static/images/warn.png" alt="说明">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" true ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="true" />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <span>在线支付</span>
                            <img src="" alt="">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <span>在线支付</span>
                            <img src="" alt="">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <span>在线支付</span>
                            <img src="" alt="">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <span>在线支付</span>
                            <img src="" alt="">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <span>在线支付111</span>
                            <img src="" alt="">
                        </div>
                        <div class="payWay_content_children_right">
                            <div class="customFrom_content_ridao">
                                    <div
                                        :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                        v-if="true"
                                        >
                                        <img src="/static/images/check.png" alt="check" v-show="false" />
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="PoperContentBtn" @click="closePayWay">确认</div>
        </div>
      </OrderPopup>


        <!-- 优惠券弹窗 -->
       <OrderPopup ref="customMyVouchers" @closeMyVouchersFun="closeMyVouchers">
         <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox">
                <div class="myVouchersBox">
                    <div class="changeCityBox_top" style="border-bottom:0;">
                        <div class="changeCityBox_top_left">
                            <span>优惠券</span>
                        </div>
                        <div class="changeCityBox_top_right">
                        <div class="weixinAdress_closeIcon" @click="closeMyVouchers">
                                <span class="weixinAdress_closeIcon_left"></span>
                                <span class="weixinAdress_closeIcon_right"></span>
                            </div>
                        </div>
                    </div>
                    <div class="myVouchers_change">
                        <div class="selectMyVouchers">
                            <span>可用代金券<span>(0)</span></span>
                        </div>
                        <div class="myVouchers_change_children">
                            <span>不可用代金券<span>(9)</span></span>
                        </div>
                    </div>
                </div>

                <div class="changeCityBox_content" style="background:#F6F6F6;">
                    <!-- 没有优惠券 -->
                    <div class="changeCityBox_content_noValueBox" v-if="false">
                        <div class="changeCityBox_content_noValue payCard_noCard">
                            <img src="/static/images/order/envelopeOrder.png" alt="城市">
                            <span class="openPermissions">您还没有相关的券</span>
                        </div>
                    </div>
                    <!-- 有优惠券 -->
                    <div class="changeVouchers_ValueBox">
                        <div class="changeVouchers_Value">
                            <div class="changeVouchers_Value_children">
                                <!-- 左边价格，规则-->
                                <div class="changeVouchers_Value_children_left">
                                    <div class="changeVouchers_Value_children_top">
                                        <div class="changeVouchers_children_top_price">
                                            <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            <span class="vouchers_text">代金券</span>
                                        </div>
                                        <div class="changeVouchers_Value_children_top_guize">
                                            <span class="first_guize" style="display:block;">使用规则：</span>
                                            <span>订单满￥9999可使用</span>
                                        </div>
                                    </div>
                                    <div class="changeVouchers_Value_children_bottom">
                                        <div>
                                            <img src="/static/images/time.png" alt="time">
                                            <span>有效期:2019.11.11 至 2020.11.11</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 右边点选按钮 -->
                                <div class="changeVouchers_Value_children_right">
                                    <div class="customFrom_content_ridao">
                                        <div
                                            :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                            v-if="true"
                                            >
                                            <img src="/static/images/check.png" alt="check" v-show="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="changeVouchers_Value_children">
                                <!-- 左边价格，规则-->
                                <div class="changeVouchers_Value_children_left">
                                    <div class="changeVouchers_Value_children_top">
                                        <div class="changeVouchers_children_top_price">
                                            <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            <span class="vouchers_text">代金券</span>
                                        </div>
                                        <div class="changeVouchers_Value_children_top_guize">
                                            <span class="first_guize" style="display:block;">使用规则：</span>
                                            <span>订单满￥9999可使用</span>
                                        </div>
                                    </div>
                                    <div class="changeVouchers_Value_children_bottom">
                                        <div>
                                            <img src="/static/images/time.png" alt="time">
                                            <span>有效期:2019.11.11 至 2020.11.11</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 右边点选按钮 -->
                                <div class="changeVouchers_Value_children_right">
                                    <div class="customFrom_content_ridao">
                                        <div
                                            :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                            v-if="true"
                                            >
                                            <img src="/static/images/check.png" alt="check" v-show="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="changeVouchers_Value_children">
                                <!-- 左边价格，规则-->
                                <div class="changeVouchers_Value_children_left">
                                    <div class="changeVouchers_Value_children_top">
                                        <div class="changeVouchers_children_top_price">
                                            <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            <span class="vouchers_text">代金券</span>
                                        </div>
                                        <div class="changeVouchers_Value_children_top_guize">
                                            <span class="first_guize" style="display:block;">使用规则：</span>
                                            <span>订单满￥9999可使用</span>
                                        </div>
                                    </div>
                                    <div class="changeVouchers_Value_children_bottom">
                                        <div>
                                            <img src="/static/images/time.png" alt="time">
                                            <span>有效期:2019.11.11 至 2020.11.11</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 右边点选按钮 -->
                                <div class="changeVouchers_Value_children_right">
                                    <div class="customFrom_content_ridao">
                                        <div
                                            :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                            v-if="true"
                                            >
                                            <img src="/static/images/check.png" alt="check" v-show="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="changeVouchers_Value_children">
                                <!-- 左边价格，规则-->
                                <div class="changeVouchers_Value_children_left">
                                    <div class="changeVouchers_Value_children_top">
                                        <div class="changeVouchers_children_top_price">
                                            <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            <span class="vouchers_text">代金券</span>
                                        </div>
                                        <div class="changeVouchers_Value_children_top_guize">
                                            <span class="first_guize" style="display:block;">使用规则：</span>
                                            <span>订单满￥9999可使用</span>
                                        </div>
                                    </div>
                                    <div class="changeVouchers_Value_children_bottom">
                                        <div>
                                            <img src="/static/images/time.png" alt="time">
                                            <span>有效期:2019.11.11 至 2020.11.11</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 右边点选按钮 -->
                                <div class="changeVouchers_Value_children_right">
                                    <div class="customFrom_content_ridao">
                                        <div
                                            :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                            v-if="true"
                                            >
                                            <img src="/static/images/check.png" alt="check" v-show="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- 没有有优惠券 -->
                    <div class="changeVouchers_ValueBox" v-if="false">
                        <div class="changeVouchers_Value">
                            <div class="changeVouchers_Value_children">
                                <!-- 左边价格，规则-->
                                <div class="changeVouchers_Value_children_left">
                                    <div class="changeVouchers_Value_children_top">
                                        <div class="changeVouchers_children_top_price">
                                            <span style="display:block;" class="vouchers_price_text"><span>￥</span>35</span>
                                            <span class="vouchers_text">代金券</span>
                                        </div>
                                        <div class="changeVouchers_Value_children_top_guize">
                                            <span class="first_guize" style="display:block;">使用规则：</span>
                                            <span>订单满￥9999可使用</span>
                                        </div>
                                    </div>
                                    <div class="changeVouchers_Value_children_bottom">
                                        <div>
                                            <span>有效期:2019.11.11 至 2020.11.11</span>
                                        </div>
                                    </div>
                                </div>
                                <!-- 提示语 -->
                                <div class="noQuanTip">
                                    <img src="/static/images/time.png" alt="time">
                                    <span>订单内商品不可使用订单内商品不可使用</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="PoperContentBtn" @click="closeMyVouchers">确认</div>
        </div>
      </OrderPopup>


      <!-- 商铺名称 -->
      <OrderPopup ref="customShopName" @closeShopNameFun="closeShopName">
        <div
          slot="PoperContent"
          class="changeCityClass"
        >
            <div class="changeCityBox payWayBox">
                <div class="changeCityBox_top" style="border-bottom:0;">
                    <div class="changeCityBox_top_left">
                        <span>商铺名称</span>
                        <span class="allShopChildren">共12件商品</span>
                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon" @click="closeShopName">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>
                <div class="payWay_content shopName_content">
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <div class="shopNameImg">
                                <img src="/static/images/order/locationOrder.png" alt="商品图片">
                            </div>
                        </div>
                        <div class="payWay_content_children_right shopName_children_right">
                            <div class="payWay_content_children_right_top shopName_children_right_top">
                                <div class="top_title">
                                    <span>佳能（Canon）PowerShot G7 X Mark II 数码相机 Vlog视频拍摄Vlog视频拍摄Vlog视频拍摄 </span>
                                </div>
                                <div class="top_reduce">
                                    <span class="top_reduce_price">会员专享价</span><span>手机下单立减￥55.99</span>
                                </div>
                            </div>
                            <div class="payWay_content_children_right_bottom">
                                <div class="price_left">
                                    <span><span class="price_left_symbol">￥</span>3899</span>
                                </div>
                                <div class="price_right">
                                    <span>X<span>14</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <div class="shopNameImg">
                                <img src="/static/images/order/locationOrder.png" alt="商品图片">
                            </div>
                        </div>
                        <div class="payWay_content_children_right shopName_children_right">
                            <div class="payWay_content_children_right_top shopName_children_right_top">
                                <div class="top_title">
                                    <span>佳能（Canon）PowerShot G7 X Mark II 数码相机 Vlog视频拍摄Vlog视频拍摄Vlog视频拍摄 </span>
                                </div>
                                <div class="top_reduce">
                                    <span class="top_reduce_price">会员专享价</span><span>手机下单立减￥55.99</span>
                                </div>
                            </div>
                            <div class="payWay_content_children_right_bottom">
                                <div class="price_left">
                                    <span><span class="price_left_symbol">￥</span>3899</span>
                                </div>
                                <div class="price_right">
                                    <span>X<span>14</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <div class="shopNameImg">
                                <img src="/static/images/order/locationOrder.png" alt="商品图片">
                            </div>
                        </div>
                        <div class="payWay_content_children_right shopName_children_right">
                            <div class="payWay_content_children_right_top shopName_children_right_top">
                                <div class="top_title">
                                    <span>佳能（Canon）PowerShot G7 X Mark II 数码相机 Vlog视频拍摄Vlog视频拍摄Vlog视频拍摄 </span>
                                </div>
                                <div class="top_reduce">
                                    <span class="top_reduce_price">会员专享价</span><span>手机下单立减￥55.99</span>
                                </div>
                            </div>
                            <div class="payWay_content_children_right_bottom">
                                <div class="price_left">
                                    <span><span class="price_left_symbol">￥</span>3899</span>
                                </div>
                                <div class="price_right">
                                    <span>X<span>14</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="payWay_content_children">
                        <div class="payWay_content_children_left">
                            <div class="shopNameImg">
                                <img src="/static/images/order/locationOrder.png" alt="商品图片">
                            </div>
                        </div>
                        <div class="payWay_content_children_right shopName_children_right">
                            <div class="payWay_content_children_right_top shopName_children_right_top">
                                <div class="top_title">
                                    <span>佳能（Canon）PowerShot G7 X Mark II 数码相机 Vlog视频拍摄Vlog视频拍摄Vlog视频拍摄 </span>
                                </div>
                                <div class="top_reduce">
                                    <span class="top_reduce_price">会员专享价</span><span>手机下单立减￥55.99</span>
                                </div>
                            </div>
                            <div class="payWay_content_children_right_bottom">
                                <div class="price_left">
                                    <span><span class="price_left_symbol">￥</span>3899</span>
                                </div>
                                <div class="price_right">
                                    <span>X<span>14</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="PoperContentBtn" @click="closeShopName">确认</div> -->
        </div>
      </OrderPopup>

      <!-- 配送方式 -->
      <OrderPopup ref="customDistribution" @closeDistributionFun="closeDistribution">
          <div slot="PoperContent" class="changeCityClass">
              <div class="changeCityBox payWayBox">
                <div class="changeCityBox_top" style="border-bottom:0;">
                    <div class="changeCityBox_top_left">
                        <span>配送方式</span>
                    </div>
                    <div class="changeCityBox_top_right">
                       <div class="weixinAdress_closeIcon" @click="closeDistribution">
                            <span class="weixinAdress_closeIcon_left"></span>
                            <span class="weixinAdress_closeIcon_right"></span>
                        </div>
                    </div>
                </div>

                <!-- 先选择配送时间 -->
                <div class="distribution_content_box">
                    <div class="distribution_content">
                        <!-- 配送时间 -->
                        <div class="distribution_content_time">
                            <div class="distribution_timeTitle_box">
                                <span class="distribution_timeTitle">请先选择配送时间</span>
                            </div>
                            <div class="distribution_timeTitle_value">
                                <div class="distribution_timeValue_left">
                                    <span>2019-11-11 12:00:00</span>
                                    <img class="distribution_timeValue_downimg" src="/static/images/order/downOrder.png" alt="下箭头" />
                                </div>
                                <div class="distribution_timeValue_right">
                                    <span>12:00:00</span>
                                    <img class="distribution_timeValue_downimg" src="/static/images/order/downOrder.png" alt="下箭头" />
                                </div>
                            </div>

                        </div>
                        <!-- 选择城市，门店 -->
                        <div class="distribution_content_stores">
                            <div class="distribution_content_stores_top">
                                <div class="distribution_content_stores_topLeft">
                                    <span class="stores_text">门店配送</span>
                                    <div class="stores_changeBtn">
                                        <img src="/static/images/order/cityOrder.png" alt=""/>
                                        <span>选择附近门店</span>
                                    </div>
                                </div>
                                <div class="distribution_content_stores_topRight">
                                    <div
                                    :class=" false ? 'shoppingContent_checkRadio shoppingContent_radio' : 'shoppingContent_radio'"
                                    v-if="true"
                                    >
                                    <img src="/static/images/check.png" alt="check" v-show="false" />
                                </div>
                                </div>
                            </div>
                            <div class="distribution_content_stores_center">
                                <div class="distribution_content_stores_centerLeft">
                                    <span>选择城市</span>
                                </div>
                                <div class="distribution_content_stores_centerRight">
                                    <div class="changCity changePublic">
                                        <span>选择省选择省</span>
                                        <img class="distribution_timeValue_downimg" src="/static/images/order/downOrder.png" alt="下箭头" />
                                    </div>
                                    <div class="changShi changePublic">
                                        <span>选择市</span>
                                        <img class="distribution_timeValue_downimg" src="/static/images/order/downOrder.png" alt="下箭头" />
                                    </div>
                                    <div class="changQu changePublic">
                                        <span>选择区</span>
                                        <img class="distribution_timeValue_downimg" src="/static/images/order/downOrder.png" alt="下箭头" />
                                    </div>
                                </div>
                            </div>
                            <div class="distribution_content_stores_bottom">
                                <div class="distribution_content_stores_bottomLeft">
                                    <span>选择门店</span>
                                </div>
                                <div class="distribution_content_stores_bottomright">
                                    <span>请选择</span>
                                    <div class="right_arrow"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="PoperContentBtn" @click="closeDistribution">确认</div>
          </div>
      </OrderPopup>
    </div>
</template>
<script>
    // 引入弹出框
    import OrderPopup from "../../components/OrderPopup/OrderPopup.vue";

    export default {
        components:{
            OrderPopup
        },
        data(){
            return{
                textAreaValue:'',
                textAreaValue1:'',
                textAreaValue2:'',
                textareaArr:[
                    {
                        value:1
                    },
                    {
                        value:2
                    }
                ],
                valueFlg:false,
                // 第一层全屏阴影
                ScreenFlg:false,
                 // 第二层全屏阴影
                ScreenFlg2:false,
                //单选框弹窗
                radioScreenFlg:false,
                // 支付卡弹窗
                payScreenFlg:false,
                // 支付方式说明弹窗
                payWayFlg:false,
                // 请输入用户名
                password_noUserName:'请输入用户名',
                // 请输入密码
                password_noValue:'请输入密码'
            }
        },

        mounted(){
            let that = this
            that.orderFun()
        },

        methods:{
        // 订单接口
        orderFun() {
            let that = this;
            let req={}
            that.$F.Response({
                url: "frontend/mallorder/getordersubmitinfo",
                param: {
                    username: this.$route.query.username,
                },
                success: res => {
                if (res.code == 200) {
                   
                }else{
                    setTimeout(function() {
                        layui.use("layer", function() {
                            // 关闭loading
                            layer.closeAll("loading");
                        });
                    }, 300);
                    layui.use("layer", function() {
                        layer.alert(res.msg, {
                            icon: 0,
                            skin: "layer-ext-moon"
                        });
                    });
                }
                },
                error: () => {
                    let that = this
                    //弹出警示信息
                    layui.use("layer", function() {
                    layer.alert("请求失败", {
                        icon: 0,
                        skin: "layer-ext-moon"
                    },function () {
                            location.href = that.allData.return_url;
                        });
                    });
                }
            });
            },


            // 
            selectStatus(){
                this.valueFlg = !this.valueFlg
            },

            // 添加收货地址弹窗
            addressClick(){
                this.$refs.customAddress.showMaskFull();
            },
            closeFullAddress(){
                this.$refs.customAddress.maskCloseFull();
            },
            // 选择城市
            changeCity(){
                this.$refs.customChangeMyCity.showCustom();
            },
            closeCity(){
                this.$refs.customChangeMyCity.maskClickHidden();
            },
            // 多选弹窗
            changeCheckBox(){
                this.$refs.customChangeCheckBox.showCustom();
            },
            closeCheckBox(){
                this.$refs.customChangeCheckBox.maskClickHidden();
            },
            // 单选弹窗
            changRadio(){
                this.radioScreenFlg = true
                this.ScreenFlg = true
            },
            
            // 选择收货地址
            closeCustom(){

            },
            // 支付卡
            payCardClick(){
                this.$refs.customPayCard.showCustom()
            },
            closePayCard(){
                this.$refs.customPayCard.maskClickHidden()
            },
            // 绑定支付卡弹窗
            bindingCardClick(){
                this.ScreenFlg2 = true
                this.payScreenFlg =true
            },
            closeShadow(){
                // 收货地址单选弹窗
                this.radioScreenFlg = false
                // 遮罩层隐藏
                this.ScreenFlg = false
            },
            closeShadow2(){
                // 支付卡弹窗
                this.payScreenFlg = false
                // 遮罩层隐藏
                this.ScreenFlg2 = false
                // 支付方式说明弹窗
                this.payWayFlg = false
            },
            // 红包弹窗
            hongbaoClick(){
                this.$refs.customHongbao.showCustom()
            },
            closeHongbao(){
                this.$refs.customHongbao.maskClickHidden()
            },
            // 支付方式
            payWayClick(){
                this.$refs.customPayWay.showCustom()
            },
            closePayWay(){
                this.$refs.customPayWay.maskClickHidden()
            },
            // 支付方式说明
            instructionsClick(){
                this.payWayFlg = true
                 // 二层遮罩层显示
                this.ScreenFlg2 = true
            },
            // 关闭支付方式说明弹窗
            closePayWayFlg(){
                this.payWayFlg = false
                 // 二层遮罩层显示
                this.ScreenFlg2 = false
            },
            // 代金券
            vouchersClick(){
               this.$refs.customMyVouchers.showCustom() 
            },
            closeMyVouchers(){
                this.$refs.customMyVouchers.maskClickHidden()
            },
            // 商品的总商品
            allShopNumber(){
                this.$refs.customShopName.showCustom()
            },
            closeShopName(){
                this.$refs.customShopName.maskClickHidden()
            },
            // 配送方式
            distributionClick(){
                this.$refs.customDistribution.showCustom()
            },
            closeDistribution(){
                this.$refs.customDistribution.maskClickHidden()
            }
        }
    }
</script>


<style scoped lang="scss">
/*  引入外部scss文件 */
@import "../../../static/css/order.scss";
</style>


// WEBPACK FOOTER //
// src/pages/Order/Order.vue